export const SET_EMAIL_USUARIO = 'AUTH/SET_EMAIL_USUARIO'
export const SET_NOME_EMPRESA = 'AUTH/SET_NOME_EMPRESA'
export const SET_ID_EMPRESA = 'AUTH/SET_ID_EMPRESA'
export const SET_CPF_CNPJ = 'AUTH/SET_CPF_CNPJ'
export const SET_REPRESENTANTE_LEGAL = 'AUTH/REPRESENTANTE_LEGAL'
export const SET_REGRAS_LOGIN = 'AUTH/SET_REGRAS_LOGIN'
export const SET_LOGIN_STRATEGY = 'AUTH/SET_LOGIN_STRATEGY'
export const SET_LOGO_CLIENTE = 'AUTH/SET_LOGO_CLIENTE'
export const SET_ESCRITORIO = 'AUTH/SET_ESCRITORIO'
export const SET_TIPO_DE_ACESSO = 'AUTH/SET_TIPO_DE_ACESSO'
export const SET_ACESSO_FINANCEIRO = 'AUTH/SET_ACESSO_FINANCEIRO'
export const SET_ACESSO_ESCRITORIO = 'AUTH/SET_ACESSO_ESCRITORIO'
export const SET_FINANCEIRO_CONTRATADO = 'AUTH/SET_FINANCEIRO_CONTRATADO'
export const SET_ACESSO_FATURAMENTO = 'AUTH/SET_ACESSO_FATURAMENTO'
export const SET_FATURAMENTO_CONTRATADO = 'AUTH/SET_FATURAMENTO_CONTRATADO'
export const SET_ACESSO_RELATORIOS = 'AUTH/SET_ACESSO_RELATORIOS'
export const SET_ACESSO_RELATORIOS_CONTRATADO = 'AUTH/SET_ACESSO_RELATORIOS_CONTRATADO'
export const SET_NOME_USUARIO_LOGADO = 'AUTH/SET_NOME_USUARIO_LOGADO'
export const SET_CODIGO_FOTO_USUARIO = 'AUTH/SET_CODIGO_FOTO_USUARIO'
export const SET_PERFIL_USUARIO = 'AUTH/SET_PERFIL_USUARIO'
export const SET_ESCRITORIO_INADIMPLENTE = 'AUTH/SET_ESCRITORIO_INADIMPLENTE'
export const SET_DADOS_ALERTA_VENCIMENTO = 'AUTH/SET_DADOS_ALERTA_VENCIMENTO'
export const SET_DADOS_ALERTA_DESBLOQUEIO_ESCRITORIO = 'AUTH/SET_DADOS_ALERTA_DESBLOQUEIO_ESCRITORIO'
export const SET_ID_USUARIO_LOGADO = 'AUTH/SET_ID_USUARIO_LOGADO'
export const SET_DATA_CRIACAO_USUARIO_LOGADO = 'AUTH/SET_DATA_CRIACAO_USUARIO_LOGADO'
export const SET_SUPORTE_ONLINE_HABILITADO = 'AUTH/SET_SUPORTE_ONLINE_HABILITADO'
export const SET_DADOS_CAMPANHA_MARKETING = 'AUTH/SET_DADOS_CAMPANHA_MARKETING'
export const SET_OCULTAR_OPCAO_MENU_BANCO = 'AUTH/SET_OCULTAR_OPCAO_MENU_BANCO'
export const SET_ALERTA_STATUS_EMPRESA = 'AUTH/SET_ALERTA_STATUS_EMPRESA'
